import app from 'flarum/common/app';

/**
 * Forum-level tracker config, serialized by the backend. The backend only
 * reports `nwcTrackerActive` when a tag AND at least one group or user are
 * configured, so every check below is inert otherwise.
 */
export function trackerActive() {
  return !!(app.forum && app.forum.attribute('nwcTrackerActive'));
}

export function highlightEnabled() {
  return trackerActive() && !!app.forum.attribute('nwcTrackerHighlight');
}

/**
 * Does the given tag slug (from the route) match the configured tracker tag?
 * The setting may hold a slug or a numeric tag id.
 */
export function isTrackerTagSlug(slug) {
  if (!trackerActive() || !slug) return false;

  const configured = String(app.forum.attribute('nwcTrackerTag') || '').trim().toLowerCase();
  if (!configured) return false;

  if (String(slug).toLowerCase() === configured) return true;

  const tag = app.store.getBy('tags', 'slug', slug);
  return !!tag && String(tag.id()) === configured;
}

export function isTrackedUser(user) {
  return !!user && !!user.attribute && !!user.attribute('isNwcTracked');
}
